import { render, staticRenderFns } from "./ConfiguracionTramites.vue?vue&type=template&id=18c60b82&scoped=true&"
import script from "./ConfiguracionTramites.vue?vue&type=script&lang=js&"
export * from "./ConfiguracionTramites.vue?vue&type=script&lang=js&"
import style0 from "./ConfiguracionTramites.vue?vue&type=style&index=0&id=18c60b82&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c60b82",
  null
  
)

export default component.exports